<script>
import { mapGetters } from 'vuex'
import moment from 'moment'
import {
  formatPriceWithSign,
  nToWord
} from '@/utils/helpers'
import SidebarPenalties from '../ui/SidebarPenalties.vue'

export default {
  name: 'sidebar',
  components: {
    SidebarPenalties
  },
  props: {},
  data: () => ({
    agencyPrice: false,
    userAgree: false
  }),
  computed: {
    isUserLoggedIn() {
      return this.$store.getters['account/getAccess']
    },
    numberOfTourists() {
      return this.$store.getters['cart/getNumberOfTourists']
    },
    getCartPrices() {
      return this.$store.getters['cart/getCartPrice']
    },
    servicesList() {
      const services = this.$store.getters['cart/getCartServices']

      return {
        main: services.filter(service => service.main && service.amount),
        additional: services.filter(service => !service.main && service.amount)
      }
    },
    date() {
      const {
        startDate,
        endDate
      } = this.$store.getters['cart/getDates']

      return `${startDate} - ${endDate}`
    },
    getAllPenalties() {
      return this.$store.getters['cart/getAllPenalties']
    },
    bookingIsLoading() {
      return this.$store.state.cart.bookingIsLoading
    },
    ...mapGetters('account', [
      'checkBookingAccess',
      'checkAgencyPriceAccess'
    ])
  },
  created() {
    this.$store.dispatch('getDictionary', {
      params: {},
      config: {
        dictionaryName: 'currencies',
        target: 'cart.dictionaries.currencies'
      }
    })
  },
  methods: {
    formatDate: date => moment.unix(date).format('DD.MM.YYYY'),
    nToAdults: n => nToWord(n, ['взрослый', 'взрослых', 'взрослых']),
    nToChildren: n => nToWord(n, ['ребенок', 'ребенка', 'детей']),
    formatPrice(price) {
      const slug = this.$store.getters['cart/getCartPrice'].currency
      const dictionary = this.$store.getters.getDictionary('cart.dictionaries.currencies')

      return formatPriceWithSign(price, slug, dictionary)
    },
    submit() {
      if (this.userAgree && !this.bookingLoading) this.$parent.validateBeforeSubmit()
    }
  },
}
</script>

<template>
  <div class="sidebar app-sidebar">
    <div class="sidebar__content">
      <p class="sidebar__title">
        Информация
      </p>
      <p class="sidebar__info">
        {{ date }}
      </p>
      <p class="sidebar__info">
        {{ numberOfTourists.adults }}
        {{ nToAdults(numberOfTourists.adults) }}
        +
        {{ numberOfTourists.children }}
        {{ nToChildren(numberOfTourists.children) }}
      </p>
      <p
        v-if="false"
        class="sidebar__info sidebar__info--topped"
      >
        Тур "Вокруг Земли за 80 дней"
      </p>
      <div class="sidebar__links">
        <div
          v-if="false"
          class="sidebar__links-item"
        >
          <a
            href="javascript:;"
          >
            Правила тарифа
          </a>
        </div>
        <div class="sidebar__links-item">
          <sidebar-penalties />
        </div>
      </div>
      <p class="sidebar__title">
        Состав тура
      </p>
      <div class="sidebar__tour-structure">
        <div
          v-for="item in servicesList.main"
          :key="item.key"
          class="sidebar__service-price"
        >
          <span>{{ item.name }}</span>
          <span>{{ formatPrice(item.amount) }}</span>
        </div>
        <p
          v-if="servicesList.additional.length"
          class="sidebar__tour-structure-title"
        >
          Дополнительные услуги
        </p>
        <div
          v-for="item in servicesList.additional"
          :key="item.key"
          class="sidebar__service-price"
        >
          <span>{{ item.name }}</span>
          <span>{{ formatPrice(item.amount) }}</span>
        </div>
      </div>
      <div
        v-if="agencyPrice"
        class="sidebar__service-price sidebar__service-price--total"
      >
        <span>Итого</span>
        <span>{{ formatPrice(getCartPrices.amountAgency) }}</span>
      </div>
      <div
        v-else
        class="sidebar__service-price sidebar__service-price--total"
      >
        <span>Итого</span>
        <span>{{ formatPrice(getCartPrices.amount) }}</span>
      </div>
      <div
        v-if="agencyPrice"
        class="sidebar__service-price sidebar__service-price--markup"
      >
        <span>Комиссия</span>
        <span>{{ formatPrice(getCartPrices.markup) }}</span>
      </div>
      <div
        v-if="checkAgencyPriceAccess"
        class="sidebar__markup-trigger"
      >
        <span>Показать цену агента</span>
        <b-switch
          v-model="agencyPrice"
          size="is-small"
        />
      </div>
      <p
        :class="{ 'overdue': getAllPenalties.hasTodayOrOldPenalties}"
        class="sidebar__payment-term"
      >
        Срок предоплаты до {{ formatDate(getAllPenalties.firstPenaltyDay) }}
      </p>
      <a
        v-if="checkBookingAccess"
        href="javascript:;"
        :class="[
          { disabled: !userAgree },
          { loading: bookingIsLoading }
        ]"
        class="sidebar__btn rex-btn-main"
        @click="submit"
      >
        <b-loading
          v-if="bookingIsLoading"
          :is-full-page="false"
          :active="bookingIsLoading"
        />
        Бронировать
      </a>
      <b-checkbox
        v-if="checkBookingAccess"
        v-model="userAgree"
        class="rex-black sidebar__agreement"
      >
        Я согласен с условиями бронирования
      </b-checkbox>
    </div>
  </div>
</template>